import ModalCreateLot from "./modal-create-lot";

export default ModalCreateLot